import mitt from "mitt";

import type { WorkflowsChangedPayload } from "@/types/linkedWorkflows";

type LogicUpdateEvent = {
  current: string;
  index: number;
  [key: string]: unknown;
};
type LogicSortEvent = {
  current: string;
  newIndex: number;
  oldIndex: number;
};
type CategoryUpdateEvent = {
  slideIndex: number;
  elementIndex: number;
  index: number;
  [key: string]: unknown;
};
type CategorySortEvent = {
  slideIndex: number;
  elementIndex: number;
  newIndex: number;
  oldIndex: number;
};
type OptionDeletedEvent = {
  current: string;
  slideIndex: number;
  elementIndex: number;
  indexToRemove: number;
};
type AppEvents = Record<string, unknown> & {
  "logic:update": LogicUpdateEvent;
  "logic:sort": LogicSortEvent;
  "category:update": CategoryUpdateEvent;
  "category:sort": CategorySortEvent;
  "option:deleted": OptionDeletedEvent;
  "workflows:changed": WorkflowsChangedPayload;
  "builder:saved": { widgetId: string };
  "copy-to-clipboard": string;
};

export const emitter = mitt<AppEvents>();

export function useEmitter() {
  return emitter;
}
